class ProductGridSizeToggle extends HTMLElement {
  constructor() {
    super();
    this.$productGrid = document.querySelector("product-grid");
    this.$gridSizeToggles = this.querySelectorAll("[data-grid]");
  }

  set currentGridSize(gridSize) {
    for (let $gridSizeToggle of this.$gridSizeToggles) {
      $gridSizeToggle.classList.toggle(
        "active",
        $gridSizeToggle.dataset.grid === gridSize
      );
    }
  }

  connectedCallback() {
    for (let $gridSizeToggle of this.$gridSizeToggles) {
      $gridSizeToggle.addEventListener("click", () => {
        this.setGridSize($gridSizeToggle.dataset.grid);
      });
    }
  }

  setGridSize(gridSize) {
    this.$productGrid.gridSizeFromSession = gridSize;
  }
}

customElements.define("product-grid-size-toggle", ProductGridSizeToggle);
